import { z } from 'zod';

export const formSchema = z.object({
  vehiclePlate: z.string().optional(),
  comment: z.string().optional(),
});

export type FormSchema = z.infer<typeof formSchema>